import { Container } from 'aurelia-dependency-injection';
import {
	autoinject,
	bindable,
	bindingMode,
	computedFrom,
	containerless,
	customElement,
	inlineView,
	observable,
} from 'aurelia-framework';
import { Router } from 'aurelia-router';
import React from 'react';

import { ContextMenuButton } from '~/components/context-menu-button/context-menu-button';
import { ContextMenuItem } from '~/components/context-menu-list/context-menu-list';
import { ReactComponent } from '~/components/react-component/react-component';
import { FocusTrap } from '~/utils/focus-trap';
import { Key } from '~/utils/key';

@autoinject
@customElement('context-menu-button-react')
@inlineView('<template ref="refContainer"></template>')
export class ContextMenuButtonReact extends ReactComponent {
	@bindable({
		defaultBindingMode: bindingMode.toView,
	})
	private readonly items: ContextMenuItem[] = [];

	@bindable({
		defaultBindingMode: bindingMode.toView,
	})
	private readonly disabled?: boolean = false;

	constructor(protected element: Element) {
		super('context-menu-button-react', element);
	}

	protected render() {
		this.renderReactDOM(
			<ContextMenuButton items={this.items} disabled={this.disabled} />,
		);
	}
}
